
import { ddmmyyyyStringToDateID } from "../../../../utilities/dateUtils";
import { agregarPadStart, agregarPadStartDDMMYYYY } from "../../../../utilities/xlsxUtils";
import { FCIMovementExcelItem, FCIMovementItem, FCIMovementItemEndpoint } from "../domain/FundsImport.model";

export type FCIMovementItemWithoutInstrument = Omit<FCIMovementItem, "investmentInstrument">;

export const createAdapterFromXLSXToFCIMovement = (
  fciMovementExcelItem: FCIMovementExcelItem
): FCIMovementItemWithoutInstrument => {
  return {
    date: agregarPadStartDDMMYYYY(fciMovementExcelItem["Fecha Liquidación"]) || "-",
    investmentMovementType: {
      name: fciMovementExcelItem["Movimiento"]
    },
    fundUnit: fciMovementExcelItem["Cuotapartes"] || "-",
    ssn: fciMovementExcelItem["SSN"] || "-"
  };
};

export const createAdapterFromFCIMovementToEndpoint = (
  fciMovementItem: FCIMovementItem
): FCIMovementItemEndpoint => {
  const formattedItem: FCIMovementItemEndpoint = {
    FechaLiquidacion: ddmmyyyyStringToDateID((fciMovementItem.date).toString(), "/"),
    InstrumentoInversionID: fciMovementItem.investmentInstrument.id!,
    TipoMovimientoInversionID: fciMovementItem.investmentMovementType.id!,
    Cuotapartes: parseFloat(fciMovementItem.fundUnit.toString().replace(/,/g, '')),
  };
  return formattedItem;
};